// extracted by mini-css-extract-plugin
export default {"btn":"TimeSelectM_btn__v3rNf","click":"TimeSelectM_click__4O9fa"};